import {displayModes} from 'services/enums/displayModes';
import Columns from './columns';

// CARE: ALWAYS INCREMENT THE VERSION IF THE SETTINGS FOR A COLUMN CHANGE!
// Config explanation
// optional: determines if the hidden status can be changed by the user
// hidden: determines if the field is shown or hidden
// conditional: indicates that the hidden status can be overriden using the conditions dictionary of the useTableConfig hook
const DefaultConfig = {
  [displayModes.admin]: {
    version: 5,
    columns: {
      templateStopInstanceId: {
        columnName: Columns.templateStopInstanceId.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 1,
      },
      stopType: {
        columnName: Columns.stopType.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 2
      },
      shipper: {
        columnName: Columns.shipper.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 3
      },
      tourId: {
        columnName: Columns.tourId.name,
        optional: true,
        hidden: true,
        conditional: false,
        order: 4
      },
      carrier: {
        columnName: Columns.carrier.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 5
      },
      microHub: {
        columnName: Columns.microHub.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 6
      },
      stopCategory: {
        columnName: Columns.stopCategory.name,
        optional: true,
        hidden: false,
        conditional: false,
        order: 7
      },
      name: {
        columnName: Columns.name.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 8
      },
      deliveryWindow: {
        columnName: Columns.deliveryWindow.name,
        optional: true,
        hidden: true,
        conditional: false,
        order: 9
      },
      options: {
        columnName: Columns.options.name,
        optional: false,
        hidden: false,
        conditional: true,
        order: 10
      },
    }
  },
  [displayModes.carrier]: {
    version: 3,
    columns: {
      templateStopInstanceId: {
        columnName: Columns.templateStopInstanceId.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 1,
      },
      tourId: {
        columnName: Columns.tourId.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 2,
      },
      carrier: {
        columnName: Columns.carrier.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 3
      },
      microHub: {
        columnName: Columns.microHub.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 4
      },
      stopCategory: {
        columnName: Columns.stopCategory.name,
        optional: true,
        hidden: false,
        conditional: false,
        order: 5
      },
      name: {
        columnName: Columns.name.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 6
      },
      streetAndNumber: {
        columnName: Columns.streetAndNumber.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 7
      },
      zipcode: {
        columnName: Columns.zipcode.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 8
      },
      deliveryWindow: {
        columnName: Columns.deliveryWindow.name,
        optional: true,
        hidden: true,
        conditional: false,
        order: 9
      },
      options: {
        columnName: Columns.options.name,
        optional: false,
        hidden: false,
        conditional: true,
        order: 10
      },
    }
  },
  [displayModes.shipper]: {
    version: 3,
    columns: {
      templateStopInstanceId: {
        columnName: Columns.templateStopInstanceId.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 1,
      },
      carrier: {
        columnName: Columns.carrier.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 2
      },
      microHub: {
        columnName: Columns.microHub.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 3
      },
      stopCategory: {
        columnName: Columns.stopCategory.name,
        optional: true,
        hidden: false,
        conditional: false,
        order: 4
      },
      name: {
        columnName: Columns.name.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 5
      },
      streetAndNumber: {
        columnName: Columns.streetAndNumber.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 6
      },
      zipcode: {
        columnName: Columns.zipcode.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 7
      },
      deliveryWindow: {
        columnName: Columns.deliveryWindow.name,
        optional: true,
        hidden: true,
        conditional: false,
        order: 8
      },
      options: {
        columnName: Columns.options.name,
        optional: false,
        hidden: false,
        conditional: true,
        order: 9
      },
    }
  },
}

export default DefaultConfig;